import { Badge, Box, Breadcrumbs, Container, Text } from '@mantine/core'
import { IconCaretRightFilled } from '@tabler/icons-react'
import { useRouter } from '@tanstack/react-router'
import { PropsWithChildren } from 'react'

export function PageHeader({ children }: PropsWithChildren<object>) {
  return (
    <Container fluid mb="sm" mt="lg">
      <Breadcrumbs data-testid="pageBreadcrumb">{children}</Breadcrumbs>
    </Container>
  )
}

function Title({ children }: PropsWithChildren<object>) {
  return <Box fz="xl">{children}</Box>
}

PageHeader.Title = Title

function Actions({ children }: PropsWithChildren<object>) {
  return <Box>{children}</Box>
}

PageHeader.Actions = Actions

export function NavTag({
  code,
  identity,
  back,
  children,
  sub,
}: PropsWithChildren<{
  code?: string
  identity?: string
  back?: number
  sub?: boolean
}>) {
  const { history } = useRouter()
  return (
    <Box
      component="a"
      onClick={() => back && history.go(back * -1)}
      style={{
        cursor: back ? 'pointer' : 'default',
      }}
    >
      {code && (
        <Box
          component="code"
          bg="rgb(64, 93, 114)"
          fz="md"
          px="8"
          py="2"
          mr="xs"
          fw="bold"
          c="#eeeeee"
          style={{ '--radius': '0.2rem', borderRadius: 'var(--radius)' }}
        >
          {code}
        </Box>
      )}
      {sub && (
        <Text px="4" span style={{ position: 'relative', top: '3px' }}>
          <IconCaretRightFilled size={16} color="gray.6" />
        </Text>
      )}
      <Text fz="lg" fw="500" span>
        {children}
      </Text>
      {identity && (
        <Badge component="code" bg="gray.6" fz="md" ml={10}>
          {identity}
        </Badge>
      )}
    </Box>
  )
}
